function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: "50%",
  cy: "50%",
  r: "50%"
}), /*#__PURE__*/React.createElement("path", {
  transform: "scale(1.6) translate(0, -1)",
  d: "M7.43 12.008v-.818a3.88 3.88 0 0 1-1.955-.81l.523-.744c.466.376.908.622 1.44.703V8.737c-1.194-.311-1.75-.76-1.75-1.693 0-.883.72-1.48 1.741-1.562v-.474h.663v.49a3.22 3.22 0 0 1 1.562.622l-.458.769a2.818 2.818 0 0 0-1.113-.524V7.92c1.243.31 1.775.81 1.775 1.7 0 .892-.728 1.49-1.766 1.58v.809h-.663zm.007-4.26v-1.44c-.515.04-.785.319-.785.695 0 .335.156.556.785.744zm.646 2.624c.516-.04.81-.302.81-.711 0-.36-.172-.58-.81-.769v1.48z",
  fill: "#000"
}));

var SvgDollarIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dollar_icon.c5f68bbd.svg";
export { ForwardRef as ReactComponent };